// Supabase Configuration
// If environment variables don't work in your build system,
// you can hardcode your credentials here (they're safe to expose in frontend)

export const SUPABASE_CONFIG = {
  url: 'https://dhfvtmzvitkdydjgzrov.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRoZnZ0bXp2aXRrZHlkamd6cm92Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ2OTM0NTYsImV4cCI6MjA4MDI2OTQ1Nn0.TrTAuA9kv3LoX-Oq1_rTt9w0sn8MCKIvqBxnOAdDXxM',
}

// Note: The anon key is safe to expose in your frontend code.
// It's designed to be public and is protected by Row Level Security (RLS) in Supabase.
